import { createContext, useContext } from 'react'
import type { ClearReason } from './token-store'

/** A sessão do portal (RN-POR-03): só há token ou não há; o resto a API decide a cada chamada. */
export interface PortalSession {
  status: 'signed_in' | 'signed_out'
  /** Por que a pessoa está fora: a sessão terminou (401) ou ela saiu. `null` se nunca entrou nesta aba. */
  reason: ClearReason | null
  /** O código certo devolveu o token: guarda e passa a mandar em toda chamada. */
  signIn(token: string): void
  /** "Sair": encerra a sessão na API e apaga o token deste aparelho. */
  signOut(): Promise<void>
}

export const SessionContext = createContext<PortalSession | null>(null)

export function useSession(): PortalSession {
  const session = useContext(SessionContext)
  if (!session) throw new Error('useSession precisa do AppProviders.')
  return session
}
